import { inject, Injectable } from '@angular/core';
import { WidgetBaseFilterModel } from '@clean-code/models';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type {
  DashboardOrderHknVolumeAppliedFilters,
  DashboardOrderHknVolumeItem,
} from '../models/market-hkn-customers.model';

@Injectable({
  providedIn: 'root',
})
export class MarketHknCustomersService {
  private graphqlService = inject(GraphqlService);

  public dashboardOrderHknVolume$(
    value: WidgetBaseFilterModel,
  ): Observable<DashboardOrderHknVolumeItem[]> {
    const query = `
      query ($input: WidgetBaseFilterInput!) {
        dashboardOrderHknVolume(input: $input) {
          id
          name
          valuesByYear {
            deliveryYear
            positionValuesByType {
              key
              value {
                closedAmount
                deliveryClosedAmount
                deliveryOpenAmount
                contractAmount
                openAmount
              }
            }
            totalAmount
          }
        }
      }`;

    return this.graphqlService
      .query<DashboardOrderHknVolumeItem[]>(query, {
        input: value,
      })
      .pipe(map((data) => data ?? []));
  }

  public dashboardOrderHknVolumeAppliedFilters$(
    value: WidgetBaseFilterModel,
  ): Observable<DashboardOrderHknVolumeAppliedFilters> {
    const query = `
      query ($input: WidgetBaseFilterInput!) {
        dashboardOrderHknVolumeAppliedFilters(input: $input) {
          marketAreaName
          deliveryAreaName
          segmentName
          kamNames
          companyNames
          years
          tradeDateFrom
          tradeDateTo
        }
      }`;

    return this.graphqlService
      .query<DashboardOrderHknVolumeAppliedFilters | null>(
        query,
        {
          input: value,
        },
        undefined,
        {
          ignoreNullCheckFilter: true,
        },
      )
      .pipe(
        map((data) => ({
          marketAreaName: data?.marketAreaName ?? null,
          deliveryAreaName: data?.deliveryAreaName ?? null,
          segmentName: data?.segmentName ?? null,
          kamNames: data?.kamNames ?? [],
          companyNames: data?.companyNames ?? [],
          years: data?.years ?? [],
          tradeDateFrom: data?.tradeDateFrom ?? null,
          tradeDateTo: data?.tradeDateTo ?? null,
        })),
      );
  }
}
